import { stats } from "@/mocks/comics";

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden bg-primary-700 py-14 md:py-20">
      <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-accent-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-10 -left-10 h-56 w-56 rounded-full bg-primary-500/30 blur-3xl"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
              <i className="ri-focus-3-line text-accent-500"></i>
              关于漫漫漫画
            </span>
            <h2 className="font-heading mt-5 text-3xl font-bold leading-snug text-background-50 md:text-5xl">
              一座
              <span className="text-accent-500">取之不尽的漫画宝库</span>
              ，让每个人都能轻松找到好故事
            </h2>
            <p className="mt-6 text-base leading-relaxed text-background-100 md:text-lg">
              漫漫漫画致力于打造一个分类清晰、合集丰富、海量收录的漫画大全平台。我们聚合全站优质漫画全集，从热门连载到冷门佳作一网打尽，让每一位读者都能在忙碌生活里，快速找到属于自己的那一个好故事。
            </p>
            <p className="mt-4 text-base leading-relaxed text-background-100 md:text-lg">
              我们始终坚持尊重原创、内容至上的原则，精心维护分类目录与合集体系，力求让「找漫不迷路」成为每一部好作品与每一位读者相遇的起点。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg bg-white/10 px-4 py-4 text-center backdrop-blur"
                >
                  <p className="font-heading text-2xl font-bold text-accent-500 md:text-3xl">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-xl">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20reading%20corner%20with%20a%20person%20relaxing%20with%20comics%20and%20warm%20candle%20light%2C%20flat%20stylized%20illustration%2C%20warm%20orange%20and%20coral%20palette%2C%20comfortable%20homey%20atmosphere%2C%20storytelling%20art&width=900&height=700&seq=mm-about&orientation=portrait"
                alt="漫漫漫画阅读场景插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -left-4 hidden items-center gap-3 rounded-xl border border-background-200/70 bg-background-50 px-5 py-4 shadow-sm sm:flex md:-left-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-heart-3-fill text-xl"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">48000+ 条好评</p>
                <p className="text-xs text-foreground-500">来自读者的真实口碑</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}